import type { IconSvgObject } from './types';

const ArrowLeftFromLineIcon: IconSvgObject = [
  ["path", { d: "M4 12H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.99996 7C8.99996 7 4.00001 10.6824 4 12C3.99999 13.3176 9 17 9 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 7V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowLeftFromLineIcon;
